// 两段文字字面上有多像：字的二元组的 Dice 系数（0 到 1，两边对称），和 lingzhi-studio 挑「过去的你」用的同一个算法。
// 不调用模型；思考讨论的「过去的你」提示、观点里的「相近」都用它。

export function alike(a: string, b: string): number {
  const x = grams(a)
  const y = grams(b)
  if (!x.size || !y.size) return 0
  let hit = 0
  for (const g of x) if (y.has(g)) hit++
  return (2 * hit) / (x.size + y.size)
}

function grams(s: string) {
  const t = s.toLowerCase().replace(/[\s\p{P}\p{S}]+/gu, '')
  const g = new Set<string>()
  for (let i = 0; i < t.length - 1; i++) g.add(t.slice(i, i + 2))
  return g
}
